"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Segment = _interopRequireDefault(require("./Segment"));

var _constants = require("./constants");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["data", "spacing"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ReactSvgDonutChart = function ReactSvgDonutChart(_ref) {
  var data = _ref.data,
      spacing = _ref.spacing,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var total = data.reduce(function (prev, current) {
    return current.value + prev;
  }, 0);
  var percentAcc = 0;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 ".concat(_constants.width, " ").concat(_constants.width)
  }, rest), {}, {
    children: data.map(function (d, i) {
      var percent = Math.round(d.value / Math.ceil(total) * 100);
      var DashArrayPercent = spacing < 0 || percent - spacing < 0 ? percent : percent - spacing;
      var DashArraylength = spacing < 0 || percent + spacing > 100 ? 100 - percent : 100 - percent + spacing;
      var strokeDasharray = "".concat(DashArrayPercent, " ").concat(DashArraylength);
      var strokeDashoffset = i === 0 ? 0 : 100 - percentAcc;
      percentAcc += percent;
      return percent > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Segment.default, _objectSpread({
        strokeDasharray: strokeDasharray,
        strokeDashoffset: strokeDashoffset
      }, d), i);
    })
  }));
};

ReactSvgDonutChart.propTypes = {
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    stroke: _propTypes.default.string.isRequired,
    strokeWidth: _propTypes.default.number,
    title: _propTypes.default.string,
    value: _propTypes.default.number.isRequired
  })),
  spacing: _propTypes.default.number
};
ReactSvgDonutChart.defaultProps = {
  data: [],
  spacing: 0
};
var _default = ReactSvgDonutChart;
exports.default = _default;
//# sourceMappingURL=index.js.map